// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { updateRequisitionLine as updateRequisitionLineApi } from "@insite/client-framework/Services/RequisitionService";
import loadRequisition from "@insite/client-framework/Store/Data/Requisitions/Handlers/LoadRequisition";
import {
    chain,
    RequestUpdateRequisitionLine,
    ResetRequisitionsData,
} from "@insite/client-framework/Store/Pages/Requisitions/Handlers/UpdateRequisitionLine";

export const XngRequestUpdateRequisitionLine: typeof RequestUpdateRequisitionLine = async props => {
    const data = await updateRequisitionLineApi({
        requisitionId: props.parameter.requisitionId,
        requisitionLineId: props.parameter.requisitionLineId,
        requisitionLine: props.parameter.requisitionLine,
    });
    if (data.successful) {
        // instead of calling the api on reset call it when ever we have success attempt
        props.dispatch(
            loadRequisition({
                requisitionId: props.parameter.requisitionId,
                expand: ["requisitionLines"],
            }),
        );
    }
};

export const XngResetRequisitionsData: typeof ResetRequisitionsData = props => {
    /**
     * Stop reseting page by commenting below code
     * props.dispatch({
     * type: "Data/Requisitions/Reset",
     * });
     */
};

replaceInChain(chain, RequestUpdateRequisitionLine, XngRequestUpdateRequisitionLine);

replaceInChain(chain, ResetRequisitionsData, XngResetRequisitionsData);
